import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-1 w-full animate-slideFadeIn" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["type", "value", "placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "text-xs text-red-500 mt-1"
}
const _hoisted_5 = {
  key: 1,
  class: "text-xs mt-1 text-yellow-600"
}
const _hoisted_6 = {
  key: 2,
  class: "text-xs mt-1 text-green-600"
}

import { ref, computed } from "vue";
import { Eye, EyeOff } from "lucide-vue-next";


export default /*@__PURE__*/_defineComponent({
  __name: 'FormInput',
  props: {
    modelValue: String,
    placeholder: String,
    type: { type: String, default: "text" },
    error: String,
    isStrongMessage: String,
    isConfirmedMessage: String,
},
  emits: ["update:modelValue"],
  setup(__props) {

const props = __props;


const showPassword = ref(false);

const computedType = computed(() => {
    if (props.type === "password") {
        return showPassword.value ? "text" : "password";
    }
    return props.type;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: computedType.value,
        value: __props.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (
                _ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value)
                )),
        placeholder: __props.placeholder,
        class: "w-full rounded-2xl px-4 py-3 text-sm pr-12 bg-transparent border border-gray-300 text-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-none transition"
      }, null, 40, _hoisted_3),
      (__props.type === 'password')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showPassword.value = !showPassword.value)),
            class: "absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition"
          }, [
            (!showPassword.value)
              ? (_openBlock(), _createBlock(_unref(Eye), {
                  key: 0,
                  class: "w-5 h-5",
                  "stroke-width": 1.5
                }))
              : (_openBlock(), _createBlock(_unref(EyeOff), {
                  key: 1,
                  class: "w-5 h-5",
                  "stroke-width": 1.5
                }))
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "icon")
    ]),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.error), 1))
      : (__props.isStrongMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.isStrongMessage), 1))
        : (__props.isConfirmedMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.isConfirmedMessage), 1))
          : _createCommentVNode("", true)
  ]))
}
}

})